import React from 'react'

const paginationLabels = {
  'jump-next': 'Jump to more pages',
  'jump-prev': 'Jump to more pages',
  next: 'Next page',
  prev: 'Previous page',
}

/**
 * Accessible itemRender factory for Ant Design Pagination / Table pagination.
 * Pass the current active page so aria-current="page" is set correctly.
 *
 * Usage:
 *   pagination={{ itemRender: makePaginationItemRender(page), ... }}
 */
export const makePaginationItemRender = activePage => (current, type, originalElement) => {
  const isPage = type === 'page'
  const label = isPage ? `Page ${current}` : paginationLabels[type]
  if (!label) return originalElement
  return React.cloneElement(
    originalElement,
    /** @type {any} */ ({
      'aria-current': isPage && current === activePage ? 'page' : undefined,
      'aria-label': label,
      tabIndex: 0,
      title: '',
      ...(!isPage && {
        children: <span aria-hidden="true">{originalElement.props.children}</span>,
      }),
    }),
  )
}

/**
 * Patches the pagination DOM inside a container to use proper ARIA roles.
 * Call inside a useEffect with a MutationObserver so it re-runs on page changes.
 */
export const patchPaginationAria = container => {
  if (!container) return
  const paginationUl = container.querySelector('.ant-pagination')
  if (!paginationUl) return
  paginationUl.setAttribute('role', 'navigation')
  paginationUl.setAttribute('aria-label', 'Table pagination')
  paginationUl.querySelectorAll('li').forEach(li => li.setAttribute('role', 'none'))
}
